<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-07-22 17:51:04
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-04-13 15:09:30
 * @Description: file content
 t7	如是楼盘信息
 -->
<template>
  <div class="t7_zd" v-if="pageInfo&&pageInfo.Extinfo">
    <remote-script
      charset="utf-8"
      src="https://map.qq.com/api/js?v=2.exp&key=MDGBZ-JJD36-HBASY-M23ME-PRFZZ-BMFQP&callback=qqMapCallback"
    ></remote-script>
    <div style="padding-bottom:60px;">
      <!-- banner -->
      <div class="banner" v-if="pageInfo.Extinfo.buildingBanner">
        <swiper class="banner_swiper" ref="bannerSwiper" :options="banner.swiperOption">
          <swiperSlide v-for="(item,index) in pageInfo.Extinfo.buildingBanner" :key="index">
            <!-- ?x-oss-process=image/resize,w_1000/format,jpg -->
            <img v-lazy="item.main_img" @click="tapBanner(item)" />
          </swiperSlide>
          <div class="swiper-pagination" slot="pagination"></div>
          <!-- <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>-->
          <!-- <div class="swiper-scrollbar" slot="scrollbar"></div> -->
        </swiper>
      </div>
      <!-- 项目信息 -->
      <div class="zd_pro_info">
        <div class="info" v-if="pageInfo.Extinfo.buildingName||pageInfo.Extinfo.unitPrice">
          <div class="tag-layer">
            <div
              class="tag"
              v-for="(tag,tagIndex) in advantages"
              :class="{red: tagIndex == 0}"
              v-if="tag&&tagIndex<4"
            >{{tag}}</div>
          </div>

          <div class="fangdai" v-if="isHuafa" @click="clickGoFd()"></div>

          <div
            class="houseName"
            v-if="pageInfo.Extinfo.buildingName"
          >{{pageInfo.Extinfo.buildingName}}</div>
          <div class="huosePrice" v-if="pageInfo.Extinfo.unitPrice">
            <span>{{pageInfo.Extinfo.unitPrice}}</span>
            <div>参考均价</div>
          </div>
          <div class="projectphone" v-if="pageInfo.Extinfo.projectTel">
            <span @click="clickProjectPhone">{{pageInfo.Extinfo.projectTel}}</span>
          </div>
          <div class="item zd">
            <!-- <span class="name">楼盘地址</span> -->
            <span class="value" @click="clickAddress">{{pageInfo.Extinfo.address}}</span>
            <img
              class="icon_map"
              @click="clickNav"
              src="https://assets.rurushishi.com/yq-rs-make/huafa/daohang.png"
              alt
            />
          </div>
          <div class="item more" v-if="isShowDetailMore==false" @click="showDetailMore">更多信息</div>
        </div>
        <div class="detail" v-if="isShowDetailMore&&detailList">
          <div class="item" v-if="isShowDetailMore==false">
            <span class="name">装修状况</span>
            <span class="value">{{myDecorateLevel[pageInfo.Extinfo.decorateLevel || 0]}}</span>
          </div>
          <div class="item" v-for="(item,index) in detailList" :key="index" v-if="item.value!='待定'">
            <span class="name">{{item.name}}</span>
            <span class="value" @click="clickDetailItem(item.name)">
              {{item.value}}
              <img
                v-if="item.name=='楼盘地址'"
                class="icon_map"
                @click="clickNav"
                src="https://assets.rurushishi.com/yq-rs-make/huafa/daohang.png"
                alt
              />
            </span>
          </div>
        </div>
      </div>

      <div class="zd_visitors">
        <Visitors></Visitors>
      </div>
      <!-- 活动区配置 小程序环境下因为活动还不支持https暂时隐藏 -->
      <div class="zd_actareas" v-if="isShowActAreas">
        <ActAreas></ActAreas>
      </div>
      <!-- 项目动态 -->
      <!-- <div class="myline" v-if="dynamicList&&dynamicList.length>0"></div> -->
      <div
        style="margin-top: .2rem"
        class="infoTitle huxing"
        v-if="dynamicList&&dynamicList.length>0"
      >
        <span>项目动态</span>
      </div>
      <IndexDynamic v-if="dynamicList&&dynamicList.length>0" :list="dynamicList"></IndexDynamic>
      <!-- 户型图 -->
      <!-- <div class="myline" v-if="floorPlanList&&floorPlanList.length>0"></div>
      <div class="infoTitle huxing" v-if="floorPlanList&&floorPlanList.length>0">
        <span>户型图</span>
      </div>
      <IndexHouse v-if="floorPlanList&&floorPlanList.length>0" :list="floorPlanList"></IndexHouse>-->
      <!-- 带我看楼盘图片 -->
      <div class="zd-common-box" v-if="floorPlanList&&floorPlanList.length>0">
        <div class="infoTitle huxing" v-if="floorPlanList&&floorPlanList.length>0">
          <span>楼盘鉴赏</span>
        </div>
        <div class="photo">
          <div
            class="item item1"
            @click="clickPhoto(pageInfo.Extinfo.floorPlan&&pageInfo.Extinfo.floorPlan.length>0&&3)"
          >
            <img
              v-lazy="pageInfo.Extinfo.floorPlan&&pageInfo.Extinfo.floorPlan.length>0?pageInfo.Extinfo.floorPlan[0].main_img:'https://assets.rurushishi.com//yq-rs-make/t7/photo_1_2.png'"
              alt
            />
            <div
              class="name"
              v-if="pageInfo.Extinfo.floorPlan&&pageInfo.Extinfo.floorPlan.length>0"
            >户型图</div>
            <!-- <div class="no" v-if="!(pageInfo.Extinfo.floorPlan&&pageInfo.Extinfo.floorPlan.length>0)"></div> -->
          </div>
          <div
            class="item item2"
            @click="clickPhoto(pageInfo.Extinfo.video&&pageInfo.Extinfo.video.length>0&&4)"
          >
            <img
              v-lazy="pageInfo.Extinfo.video&&pageInfo.Extinfo.video.length>0?pageInfo.Extinfo.video[0].main_img:'https://assets.rurushishi.com//yq-rs-make/t7/photo_2_2.png'"
              alt
            />
            <div class="name" v-if="pageInfo.Extinfo.video&&pageInfo.Extinfo.video.length>0">视频VR</div>
            <!-- <div class="no" v-if="!(pageInfo.Extinfo.video&&pageInfo.Extinfo.video.length>0)"></div> -->
          </div>
          <div
            class="item item3"
            @click="clickPhoto(pageInfo.Extinfo.samplePlate&&pageInfo.Extinfo.samplePlate.length>0&&1)"
          >
            <img
              v-lazy="pageInfo.Extinfo.samplePlate&&pageInfo.Extinfo.samplePlate.length>0?pageInfo.Extinfo.samplePlate[0].main_img:'https://assets.rurushishi.com//yq-rs-make/t7/photo_3_2.png'"
              alt
            />
            <div
              class="name"
              v-if="pageInfo.Extinfo.samplePlate&&pageInfo.Extinfo.samplePlate.length>0"
            >精美内景</div>
            <!-- <div
              class="no"
              v-if="!(pageInfo.Extinfo.samplePlate&&pageInfo.Extinfo.samplePlate.length>0)"
            ></div>-->
          </div>
          <div
            class="item item4"
            @click="clickPhoto(pageInfo.Extinfo.envImages&&pageInfo.Extinfo.envImages.length>0&&2)"
          >
            <img
              v-lazy="pageInfo.Extinfo.envImages&&pageInfo.Extinfo.envImages.length>0?pageInfo.Extinfo.envImages[0].main_img:'https://assets.rurushishi.com//yq-rs-make/t7/photo_4_2.png'"
              alt
            />
            <div
              class="name"
              v-if="pageInfo.Extinfo.envImages&&pageInfo.Extinfo.envImages.length>0"
            >周边环境</div>
            <!-- <div class="no" v-if="!(pageInfo.Extinfo.envImages&&pageInfo.Extinfo.envImages.length>0)"></div> -->
          </div>
        </div>
      </div>

      <div class="zd-common-box" v-if="isShowSales&&salespersonList&&salespersonList.length>0">
        <div class="infoTitle huxing" v-if="isShowSales&&salespersonList&&salespersonList.length>0">
          <span>销售顾问</span>
        </div>
        <ScrollViewHorSalesperson
          v-if="isShowSales&&salespersonList&&salespersonList.length>0"
          :list="salespersonList"
        ></ScrollViewHorSalesperson>
      </div>

      <div class="zd-common-box" v-if="pageInfo.Extinfo.projectInfo">
        <div class="infoTitle huxing" v-if="pageInfo.Extinfo.projectInfo">
          <span>项目介绍</span>
        </div>
        <div
          class="houseIntroduce"
          v-if="pageInfo.Extinfo.projectInfo"
          v-html="pageInfo.Extinfo.projectInfo"
        ></div>
      </div>

      <div class="zd-common-box" v-if="pageInfo.Extinfo.lat">
        <div class="infoTitle huxing" v-if="pageInfo.Extinfo.lat">
          <span class="bg4">周边配套</span>
        </div>
        <div class="t7_map" style="margin: 0.2rem 2px 0 2px;" v-show="pageInfo.Extinfo.lat">
          <t7Map></t7Map>
        </div>
        <div class="zhoubian">
          <div
            class="zhoubian_subtitle jiaoyupeitao"
            v-if="pageInfo.Extinfo.educationInfo&&pageInfo.Extinfo.educationInfo.length>0"
          >教育配套</div>
          <div
            class="zhoubian_content jiaoyupeitao"
            v-if="pageInfo.Extinfo.uiEducationInfoType=='array'&&pageInfo.Extinfo.educationInfo&&pageInfo.Extinfo.educationInfo.length>0"
          >
            <ul>
              <li v-for="tag in pageInfo.Extinfo.educationInfo">
                <span>{{tag}}</span>
              </li>
            </ul>
          </div>
          <div
            v-if="pageInfo.Extinfo.uiEducationInfoType=='html'&&pageInfo.Extinfo.educationInfo"
            class="zhoubian_content jiaoyupeitao"
            v-html="pageInfo.Extinfo.educationInfo"
          ></div>
          <div v-show="showMore">
            <div
              class="zhoubian_subtitle shenghuopeitao"
              v-if="pageInfo.Extinfo.liveFacilities&&pageInfo.Extinfo.liveFacilities.length>0"
            >生活配套</div>
            <div
              class="zhoubian_content shenghuopeitao"
              v-if="pageInfo.Extinfo.uiLiveFacilitiesType=='array'&&pageInfo.Extinfo.liveFacilities&&pageInfo.Extinfo.liveFacilities.length>0"
            >
              <ul>
                <li v-for="tag in pageInfo.Extinfo.liveFacilities">
                  <span>{{tag}}</span>
                </li>
              </ul>
            </div>
            <div
              v-if="pageInfo.Extinfo.uiLiveFacilitiesType=='html'&&pageInfo.Extinfo.liveFacilities"
              class="zhoubian_content shenghuopeitao"
              v-html="pageInfo.Extinfo.liveFacilities"
            ></div>
            <div
              class="zhoubian_subtitle shangyepeitao"
              v-if="pageInfo.Extinfo.businessFacilities&&pageInfo.Extinfo.businessFacilities.length>0"
            >商业配套</div>
            <div
              class="zhoubian_content shangyepeitao"
              v-if="pageInfo.Extinfo.uiBusinessFacilitiesType=='array'&&pageInfo.Extinfo.businessFacilities&&pageInfo.Extinfo.businessFacilities.length>0"
            >
              <ul>
                <li v-for="tag in pageInfo.Extinfo.businessFacilities">
                  <span>{{tag}}</span>
                </li>
              </ul>
            </div>
            <div
              v-if="pageInfo.Extinfo.uiBusinessFacilitiesType=='html'&&pageInfo.Extinfo.businessFacilities"
              class="zhoubian_content shangyepeitao"
              v-html="pageInfo.Extinfo.businessFacilities"
            ></div>

            <div
              class="zhoubian_subtitle yiliaopeitao"
              v-if="pageInfo.Extinfo.medicalCareFacilities&&pageInfo.Extinfo.medicalCareFacilities.length>0"
            >医疗配套</div>
            <div
              class="zhoubian_content yiliaopeitao"
              v-if="pageInfo.Extinfo.uiMedicalCareFacilitiesType=='array'&&pageInfo.Extinfo.medicalCareFacilities&&pageInfo.Extinfo.medicalCareFacilities.length>0"
            >
              <ul>
                <li v-for="tag in pageInfo.Extinfo.medicalCareFacilities">
                  <span>{{tag}}</span>
                </li>
              </ul>
            </div>
            <div
              v-if="pageInfo.Extinfo.uiMedicalCareFacilitiesType=='html'&&pageInfo.Extinfo.medicalCareFacilities"
              class="zhoubian_content yiliaopeitao"
              v-html="pageInfo.Extinfo.medicalCareFacilities"
            ></div>

            <div
              class="zhoubian_subtitle ziranhuanjin"
              v-if="isLianShi&&pageInfo.Extinfo.lsZrhj&&pageInfo.Extinfo.lsZrhj.length>0"
            >自然环境</div>
            <div
              class="zhoubian_content ziranhuanjin"
              v-if="isLianShi&&pageInfo.Extinfo.uilsZrhjType=='array'&&pageInfo.Extinfo.lsZrhj&&pageInfo.Extinfo.lsZrhj.length>0"
            >
              <ul>
                <li v-for="tag in pageInfo.Extinfo.lsZrhj">
                  <span>{{tag}}</span>
                </li>
              </ul>
            </div>
            <div
              v-if="isLianShi&&pageInfo.Extinfo.uilsZrhjType=='html'&&pageInfo.Extinfo.lsZrhj"
              class="zhoubian_content ziranhuanjin"
              v-html="pageInfo.Extinfo.lsZrhj"
            ></div>
          </div>
        </div>
      </div>
      <!-- 这里放置售楼处电话projectTel -->
      <div class="declare">
        特别声明
        <br />1、本公众号内所展示的房屋户型、面积、项目配套、位置等涉及的图片、文字介绍内容（包括载明的数据等信息）均为要约邀请，不构成项目开发商或运营主体的要约或承诺，具体以买卖双方签订的合同约定及政府最终审批为准；
        <br />2、项目开发或运营主体保留对本公众号内所展示房屋或其他标的涉及本声明第1项的相关要约邀请内容进行修改的权利，所修改的内容同样均为要约邀请，不构成项目开发商或运营主体的要约或承诺。
        <br />3、本公众号内涉及项目销售、介绍、推荐等各类活动的最终解释权由项目开发或运营主体享有。
      </div>
    </div>
    <Tabbar10 v-if="isHuafa"></Tabbar10>
    <Tabbar8 v-else></Tabbar8>
    <!-- lj26 -->
    <BtnHomeLayout4 v-if="isShowBtnHomeLayout4"></BtnHomeLayout4>
  </div>
</template>
<script>
window.qqMapCallback = function() {
  let tmpInterval = setInterval(() => {
    if (
      window.t4 &&
      window.t4.pd &&
      window.t4.pd.Extinfo &&
      window.t4.pd.Extinfo.lat &&
      document.getElementById("t7Map")
    ) {
      window.initmap();
      clearInterval(tmpInterval);
    }
  }, 500);
};

window.initmap = function() {
  var myLatlng = new qq.maps.LatLng(
    window.t4.pd.Extinfo.lat,
    window.t4.pd.Extinfo.lng
  );
  //获取dom元素添加地图信息
  var map = new qq.maps.Map(document.getElementById("t7Map"), {
    zoom: 13,
    center: myLatlng,
    mapTypeId: qq.maps.MapTypeId.ROADMAP,
    scaleControl: false,
    zoomControl: false
  });
  //给定位的位置添加图片标注
  var markers = new qq.maps.Marker({
    position: myLatlng,
    map: map
  });
  var marker = new qq.maps.Label({
    position: myLatlng,
    map: map,
    content: window.t4.pd.Extinfo.buildingName
  });
};
import "swiper/dist/css/swiper.css";
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import { mapState, mapMutations } from "vuex";
import { swiper, swiperSlide } from "vue-awesome-swiper";
const IndexHouse = () => import("@/components/t4/index_house");
const ScrollViewHorSalesperson = () =>
  import("@/components/scroll-view_hor_salesperson");
import wx from "weixin-js-sdk";
const Visitors = () => import("@/components/visitors");
const ActAreas = () => import("@/components/actareas");
const Tabbar8 = () => import("@/components/tabbar8");
const Tabbar10 = () => import("@/components/tabbar10");
const BtnHomeLayout4 = () => import("@/components/btn_home_layout4");
const IndexDynamic = () => import("@/components/index_dynamic");
const t7Map = () => import("@/components/t7_map");
const swiperVrVideoImage = () => import("@/components/swiper_vr_video_img");
export default {
  components: {
    swiper,
    swiperSlide,
    IndexHouse,
    ScrollViewHorSalesperson,
    Visitors,
    ActAreas,
    Tabbar8,
    Tabbar10,
    BtnHomeLayout4,
    IndexDynamic,
    t7Map,
    swiperVrVideoImage
  },
  props: {},
  data() {
    return {
      advantages: [],
      isHuafa: util.checkIsHuafa(), //是否华发
      isShowActAreas: true,
      showMore: true,
      isLianShi: false,
      floorPlanList: [],
      pd: {},
      banner: {
        swiperOption: {
          autoplay: {
            delay: 2500
          },
          pagination: {
            el: ".swiper-pagination"
          }
        },
        items: []
      },
      detailList: [],
      myDecorateLevel: ["", "毛坯", "中装", "简装", "精装", "豪装"],
      salespersonList: [], //销售员列表
      isShowSales: false,
      isShowDetailMore: false,
      showFdCalculator: true, //是否显示房贷计算器
      dynamicTitle: "",
      dynamicList: [], //项目动态
      isShowBtnHomeLayout4: false
    };
  },
  // 测试的数据?fake=henduoke_hope&id=12115&psn=3de21a22c4ca4deda68126ee087e9652
  watch: {},
  computed: {
    bannerSwiper() {
      return this.$refs.bannerSwiper.swiper;
    },
    ...mapState([
      "isShowGuide",
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "userInfo",
      "rsCardInfo"
    ])
  },
  methods: {
    ...mapMutations({
      SET_PAGEINFO: "SET_PAGEINFO"
    }),
    scrollEvent() {
      // console.log(
      //   `document.body.scrollTop:${document.body.scrollTop} this.$clientHeight:${this.$clientHeight} document.body.scrollHeight:${document.body.scrollHeight}`
      // );
      if (document.body.scrollHeight - this.$clientHeight > 100) {
        let tmpNum =
          document.body.scrollHeight -
          this.$clientHeight -
          document.body.scrollTop;
        if (tmpNum < 100) {
          this.isShowBubbleShare = true;
        } else {
          this.isShowBubbleShare = false;
        }
      }
    },
    // lj27
    tapBanner(item) {
      if (item.redirect_url) {
        util.openYqRsH5Link(item.redirect_url);
      }
    },
    clickMap() {
      if (this.isInMiniProgram) {
        wx.openLocation({
          latitude: parseFloat(this.pd.Extinfo.lat), // 纬度，浮点数，范围为90 ~ -90
          longitude: parseFloat(this.pd.Extinfo.lng), // 经度，浮点数，范围为180 ~ -180。
          name: this.pd.Extinfo.buildingName, // 位置名
          address: this.pd.Extinfo.address, // 地址详情说明
          scale: 16, // 地图缩放级别,整形值,范围从1~28。默认为最大
          infoUrl: "" // 在查看位置界面底部显示的超链接,可点击跳转
        });
      } else {
        util.openUrl(
          `http://uri.amap.com/marker?position=${this.pd.Extinfo.lng},${this.pd.Extinfo.lat}&name=${this.pd.Extinfo.buildingName}`
        );
      }
    },
    filterFloorPlan(item) {
      let that = this;
      item.forEach(function(v, i) {
        let obj = {};
        obj.main_img = v.main_img;
        obj.compress_img =
          v.main_img + "?x-oss-process=image/resize,w_300/format,jpg";
        obj.name = v.name;
        that.floorPlanList.push(obj);
      });
      console.log(that.floorPlanList);
    },
    clickProjectPhone() {
      location.href = `tel:${this.pageInfo.Extinfo.projectTel}`;
    },
    showDetailMore() {
      this.isShowDetailMore = true;
    },
    getProjectReferSalers(saleropenid, projectid) {
      if (this.$rscuid) {
        // 如果有销售和置业经纪人
        // 获取信息
        util.checkMapStateCallback(this, ["rsCardInfo"]).then(() => {
          //

          if (
            this.rsCardInfo &&
            this.rsCardInfo.headimgurl &&
            this.rsCardInfo.mobile &&
            this.rsCardInfo.openid
          ) {
            let tmpObj = {
              // firmid: 1010,
              // projectname: "绿地中央墅",
              // createtime: 1581573112000,
              // weixin: "",
              // wxqr: "",
              // roleid: 2011,
              headimgurl: this.rsCardInfo.headimgurl,
              mobile: this.rsCardInfo.mobile,
              // firmname: "绿地中央墅",
              counselorname: this.rsCardInfo.name,
              saleropenid: this.rsCardInfo.openid,
              counselornickname: this.rsCardInfo.nickname
            };
            this.salespersonList = [tmpObj];
          }
        });
      } else {
        // 因为有rscuid的一直传播了，所以没有rscuid直接获取项目全部销售列表
        comreq.getProjectReferSalers(projectid).then(data => {
          console.log("销售员列表：", data);
          if (
            data.code == 0 &&
            data.obj &&
            data.obj.list &&
            data.obj.list.length > 0
          ) {
            this.salespersonList = data.obj.list.filter(item => {
              if (item.headimgurl && item.mobile) {
                return true;
              } else {
                return false;
              }
            });
            console.log(
              "销售员列表处理前后：",
              data.obj.list,
              this.salespersonList
            );
          }
        });
      }
    },
    // lj28
    clickGoFd() {
      let link = `${location.protocol}//${location.host}/activities/housing-loan/index.html`;
      util.openOtherLink(link);
    },
    // lj49
    clickPhoto(type) {
      if (type > 0) {
        let url = `${location.protocol}//${location.host}/h5/t7_photo?type=${type}`;
        util.openYqRsMakeLink(url);
      } else {
        util.messageBox("敬请期待！");
      }
    },
    // lj47
    clickAddress() {
      if (
        this.pageInfo.Extinfo &&
        this.pageInfo.Extinfo.lng &&
        this.pageInfo.Extinfo.lat
      ) {
        let url = `${location.protocol}//${location.host}/h5/t7_map`;
        util.openYqRsMakeLink(url);
      }
    },
    clickDetailItem(name) {
      if (name == "楼盘地址") {
        this.clickAddress();
      }
    },
    clickNav() {
      if (this.isInMiniProgram) {
        wx.openLocation({
          latitude: parseFloat(this.pageInfo.Extinfo.lat), // 纬度，浮点数，范围为90 ~ -90
          longitude: parseFloat(this.pageInfo.Extinfo.lng), // 经度，浮点数，范围为180 ~ -180。
          name: this.pageInfo.Extinfo.buildingName, // 位置名
          address: this.pageInfo.Extinfo.address, // 地址详情说明
          scale: 16, // 地图缩放级别,整形值,范围从1~28。默认为最大
          infoUrl: "" // 在查看位置界面底部显示的超链接,可点击跳转
        });
      } else {
        util.openUrl(
          `http://uri.amap.com/marker?position=${this.pageInfo.Extinfo.lng},${this.pageInfo.Extinfo.lat}&name=${this.pageInfo.Extinfo.buildingName}`
        );
      }
    },
    showMoreData() {
      this.showMore = true;
    }
  },
  filters: {},
  created() {
    let that = this;
    if (this.isInMiniProgram && util.checkIsHaveOldMp()) {
      this.isShowActAreas = false;
    } else {
      this.isShowActAreas = true;
    }

    if (that.$route.query.entry == "zxslzx") {
      // 在线售楼中心 打开销售员列表
      that.isShowSales = true;
      that.isShowBtnHomeLayout4 = true;
    }
    // 润亿网络科技 隐藏销售列表
    if (that.global.SUBDOMAIN == "rywlkj") {
      that.isShowSales = false;
    }
    util
      .checkMapStateCallback(that, ["pageInfo", "receiveSpreadInfo"])
      .then(() => {
        // 获取项目动态
        if (that.pageInfo.Pid && that.pageInfo.Extinfo.tagid) {
          that.dynamicTitle = that.pageInfo.Extinfo.tagname || "项目动态";
          comreq
            .listPageInfoWithChannel3(
              parseInt(that.pageInfo.Pid),
              that.pageInfo.Extinfo.tagid
            )
            .then(data => {
              console.log("listPageInfoWithChannel3", data);
              if (data.list) {
                that.dynamicList = data.list;
              }
            });
        }

        that.pd = that.pageInfo;
        console.log(
          "that.pageInfothat.pageInfo",
          JSON.parse(JSON.stringify(that.pageInfo))
        );
        if (that.pd.Extinfo == "") {
          that.pd.Extinfo = that.json;
          return;
        }
        let tmpArr = "";
        if (
          that.pd.Extinfo &&
          that.pd.Extinfo.advantage &&
          !util.isArray(that.pd.Extinfo.advantage)
        ) {
          tmpArr = that.pd.Extinfo.advantage;
          tmpArr = tmpArr.split(",");
          if (tmpArr.length > 0) {
            tmpArr = tmpArr.filter(item => {
              return item;
            });
          }
          that.pd.Extinfo.advantage = tmpArr;
          that.advantages = tmpArr;
        }
        if (
          that.pd.Extinfo &&
          that.pd.Extinfo.trafficNavigation &&
          !util.isArray(that.pd.Extinfo.trafficNavigation)
        ) {
          tmpArr = that.pd.Extinfo.trafficNavigation;
          tmpArr = tmpArr.split("\n");
          if (tmpArr.length > 0) {
            tmpArr = tmpArr.filter(item => {
              return item;
            });
          }
          that.pd.Extinfo.trafficNavigation = tmpArr;
        }

        that.pd.Extinfo.educationInfo = decodeURIComponent(
          that.pd.Extinfo.educationInfo
        );
        that.pd.Extinfo.educationInfo = that.pd.Extinfo.educationInfo.replace(
          "white-space: nowrap;",
          ""
        );
        if (
          that.pd.Extinfo.educationInfo.indexOf("<") > -1 &&
          that.pd.Extinfo.educationInfo.indexOf(">") > -1
        ) {
          that.pd.Extinfo.uiEducationInfoType = "html";
        } else {
          that.pd.Extinfo.uiEducationInfoType = "array";
        }
        if (that.pd.Extinfo.uiEducationInfoType == "array") {
          if (that.pd.Extinfo && that.pd.Extinfo.educationInfo) {
            tmpArr = that.pd.Extinfo.educationInfo;
            tmpArr = tmpArr.split("\n");
            if (tmpArr.length > 0) {
              tmpArr = tmpArr.filter(item => {
                return item;
              });
            }
            that.pd.Extinfo.educationInfo = tmpArr;
          }
        }

        that.pd.Extinfo.liveFacilities = decodeURIComponent(
          that.pd.Extinfo.liveFacilities
        );
        that.pd.Extinfo.liveFacilities = that.pd.Extinfo.liveFacilities.replace(
          "white-space: nowrap;",
          ""
        );
        if (
          that.pd.Extinfo.liveFacilities.indexOf("<") > -1 &&
          that.pd.Extinfo.liveFacilities.indexOf(">") > -1
        ) {
          that.pd.Extinfo.uiLiveFacilitiesType = "html";
        } else {
          that.pd.Extinfo.uiLiveFacilitiesType = "array";
        }
        if (that.pd.Extinfo.uiLiveFacilitiesType == "array") {
          if (that.pd.Extinfo && that.pd.Extinfo.liveFacilities) {
            tmpArr = that.pd.Extinfo.liveFacilities;
            tmpArr = tmpArr.split("\n");
            if (tmpArr.length > 0) {
              tmpArr = tmpArr.filter(item => {
                return item;
              });
            }
            that.pd.Extinfo.liveFacilities = tmpArr;
          }
        }

        that.pd.Extinfo.businessFacilities = decodeURIComponent(
          that.pd.Extinfo.businessFacilities
        );

        that.pd.Extinfo.businessFacilities = that.pd.Extinfo.businessFacilities.replace(
          "white-space: nowrap;",
          ""
        );
        if (
          that.pd.Extinfo.businessFacilities.indexOf("<") > -1 &&
          that.pd.Extinfo.businessFacilities.indexOf(">") > -1
        ) {
          that.pd.Extinfo.uiBusinessFacilitiesType = "html";
        } else {
          that.pd.Extinfo.uiBusinessFacilitiesType = "array";
        }
        if (that.pd.Extinfo.uiBusinessFacilitiesType == "array") {
          if (that.pd.Extinfo && that.pd.Extinfo.businessFacilities) {
            tmpArr = that.pd.Extinfo.businessFacilities;
            tmpArr = tmpArr.split("\n");
            if (tmpArr.length > 0) {
              tmpArr = tmpArr.filter(item => {
                return item;
              });
            }
            that.pd.Extinfo.businessFacilities = tmpArr;
          }
        }

        that.pd.Extinfo.medicalCareFacilities = decodeURIComponent(
          that.pd.Extinfo.medicalCareFacilities
        );
        that.pd.Extinfo.medicalCareFacilities = that.pd.Extinfo.medicalCareFacilities.replace(
          "white-space: nowrap;",
          ""
        );
        if (
          that.pd.Extinfo.medicalCareFacilities.indexOf("<") > -1 &&
          that.pd.Extinfo.medicalCareFacilities.indexOf(">") > -1
        ) {
          that.pd.Extinfo.uiMedicalCareFacilitiesType = "html";
        } else {
          that.pd.Extinfo.uiMedicalCareFacilitiesType = "array";
        }
        if (that.pd.Extinfo.uiMedicalCareFacilitiesType == "array") {
          if (that.pd.Extinfo && that.pd.Extinfo.medicalCareFacilities) {
            tmpArr = that.pd.Extinfo.medicalCareFacilities;
            tmpArr = tmpArr.split("\n");
            if (tmpArr.length > 0) {
              tmpArr = tmpArr.filter(item => {
                return item;
              });
            }
            that.pd.Extinfo.medicalCareFacilities = tmpArr;
          }
        }

        that.pd.Extinfo.lsZrhj = decodeURIComponent(that.pd.Extinfo.lsZrhj);
        that.pd.Extinfo.lsZrhj = that.pd.Extinfo.lsZrhj.replace(
          "white-space: nowrap;",
          ""
        );
        if (
          that.pd.Extinfo.lsZrhj.indexOf("<") > -1 &&
          that.pd.Extinfo.lsZrhj.indexOf(">") > -1
        ) {
          that.pd.Extinfo.uilsZrhjType = "html";
        } else {
          that.pd.Extinfo.uilsZrhjType = "array";
        }
        if (that.pd.Extinfo.uilsZrhjType == "array") {
          if (that.pd.Extinfo && that.pd.Extinfo.lsZrhj) {
            tmpArr = that.pd.Extinfo.lsZrhj;
            tmpArr = tmpArr.split("\n");
            if (tmpArr.length > 0) {
              tmpArr = tmpArr.filter(item => {
                return item;
              });
            }
            that.pd.Extinfo.lsZrhj = tmpArr;
          }
        }

        if (that.pd.Extinfo.floorPlan && that.pd.Extinfo.floorPlan.length > 0) {
          that.filterFloorPlan(that.pd.Extinfo.floorPlan);
        }
        console.log("====>pd", JSON.parse(JSON.stringify(that.pd)));

        let names = null;

        names = {
          // address: "楼盘地址",
          decorateLevel: "装修状况",
          developer: "开发商",
          propertyManagement: "物业公司",
          bookDate: "开盘时间",
          deliverDate: "交房时间",
          buildingType: "建筑类型",
          propertyType: "物业类型",
          propertyYears: "产权年限(年)",
          parkingRatio: "车位占比(%)",
          greenRatio: "绿化率(%)",
          volumeRatio: "容积率(%)",
          propertyCosts: "物业费(元/m²)"
        };

        let buildingType = [
          "建筑类型:",
          "低层住宅",
          "多层住宅",
          "小高层住宅",
          "高层住宅",
          "商业",
          "办公",
          "高层办公",
          "洋房"
        ];
        let propertyType = [
          "物业类型:",
          "住宅",
          "酒店式公寓",
          "住宅式公寓",
          "别墅",
          "办公楼",
          "商铺",
          "商业",
          "养老度假村"
        ];
        let decorateLevel = [
          "装修类别:",
          "毛坯",
          "中装",
          "简装",
          "精装",
          "豪装"
        ];
        let bookDate = that.pd.Extinfo.bookDate;
        let deliverDate = that.pd.Extinfo.deliverDate;
        if (bookDate) {
          bookDate = that.pd.Extinfo.bookDate.split("-");
        }
        if (deliverDate) {
          deliverDate = that.pd.Extinfo.deliverDate.split("-");
        }
        for (let keys in names) {
          for (let key in that.pd.Extinfo) {
            let obj = {};
            if (keys == key) {
              obj.name = names[keys];
              if (names[keys] == "装修状况") {
                obj.value = decorateLevel[that.pd.Extinfo[key]]
                  ? decorateLevel[that.pd.Extinfo[key]]
                  : "待定";
              } else if (names[keys] == "开盘时间" && bookDate) {
                obj.value = `${bookDate[0]}年${bookDate[1]}月份`
                  ? `${bookDate[0]}年${bookDate[1]}月份`
                  : "待定";
              } else if (names[keys] == "交房时间" && deliverDate) {
                obj.value = `${deliverDate[0]}年${deliverDate[1]}月份`
                  ? `${deliverDate[0]}年${deliverDate[1]}月份`
                  : "待定";
              } else if (names[keys] == "物业类型") {
                obj.value = propertyType[that.pd.Extinfo[key]]
                  ? propertyType[that.pd.Extinfo[key]]
                  : "待定";
              } else if (names[keys] == "建筑类型") {
                obj.value = buildingType[that.pd.Extinfo[key]]
                  ? buildingType[that.pd.Extinfo[key]]
                  : "待定";
              } else {
                obj.value = that.pd.Extinfo[key]
                  ? that.pd.Extinfo[key]
                  : "待定";
              }
              that.detailList.push(obj);
            }
          }
        }
        if (that.pd.Extinfo.projectInfo) {
          that.pd.Extinfo.projectInfo = decodeURIComponent(
            that.pd.Extinfo.projectInfo
          );
          if (that.pd.Extinfo.projectInfo == "<br>") {
            that.pd.Extinfo.projectInfo = "";
          }
        }
        that.SET_PAGEINFO(that.pd);
        window.t4 = {
          pd: that.pd
        };

        // 加载销售员列表
        if (this.pageInfo && this.pageInfo.Pid) {
          if (this.$refereeopenid) {
            comreq
              .getReferSaler(this.$refereeopenid, this.pageInfo.PageId)
              .then(data => {
                console.log("getReferSaler", data);
                if (data.code == 0 && data.obj && data.obj.saleropenid) {
                  that.getProjectReferSalers(
                    data.obj.saleropenid,
                    this.pageInfo.Pid
                  );
                } else {
                  that.getProjectReferSalers("", this.pageInfo.Pid);
                }
              });
          } else {
            that.getProjectReferSalers("", this.pageInfo.Pid);
          }
          // comreq.counselorList(parseInt(this.pageInfo.Pid)).then(data => {
          //   console.log("销售员列表：", data);
          //   console.log("receiveSpreadInfo", this.receiveSpreadInfo);
          //   if (
          //     data.code == 0 &&
          //     data.obj &&
          //     data.obj.list &&
          //     data.obj.list.length > 0
          //   ) {
          //     // 如果有传播者且是销售，只展示传播者
          //     let salespersonList = data.obj.list.filter(item => {
          //       if (
          //         this.receiveSpreadInfo.refereeopenid &&
          //         this.receiveSpreadInfo.refereeopenid == item.saleropenid
          //       ) {
          //         return true;
          //       } else {
          //         return false;
          //       }
          //     });
          //     // 传播者不是销售
          //     if (salespersonList.length == 0) {
          //       salespersonList = data.obj.list.filter(item => {
          //         if (item.headimgurl && item.mobile) {
          //           return true;
          //         } else {
          //           return false;
          //         }
          //       });
          //     }
          //     console.log("销售员列表处理后：", salespersonList);
          //     this.salespersonList = salespersonList;
          //   }
          // });
        }
      });
    window.addEventListener("scroll", that.scrollEvent, true);
  },
  mounted() {
    if (location.host.indexOf("lianshi.") > -1) {
      this.isLianShi = true;
    }
    if (location.host.indexOf("hllsq.") > -1) {
      this.showFdCalculator = false;
    }
    if (this.isHuafa) {
      this.showMore = false;
    }
    this.editHeight = this.$clientHeight - this.$tabbarHeight;
  }
};
</script>


<style lang="css" scoped>
/* Banner */
.banner_swiper {
  width: 100%;
  /* height: 4.97rem; */
}
.banner_swiper img {
  width: 100%;
  height: 4.97rem;
  object-fit: cover;
}
/* 项目信息 */
.info {
  width: 100%;
  padding: 10px 20px 0 20px;
  box-sizing: border-box;
  z-index: 10;
  position: relative;
  /* top: -20px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px; */
  background-color: rgba(255, 255, 255, 0.7);
  text-align: justify;
  border-radius: 6px;
}
.info .houseName {
  width: 100%;
  line-height: 0.6rem;
  font-weight: 600;
  color: #3a3a3a;
  font-size: 18px;
}
.info .huosePrice {
  width: 100%;
  height: 0.75rem;
  font-size: 0.1rem;
  display: flex;
  line-height: 0.75rem;
}
.info .huosePrice > span {
  color: #f22321;
  font-size: 0.32rem;
  padding-right: 10px;
  font-weight: bold;
  display: block;
  line-height: 0.75rem;
}
.info .huosePrice > div {
  font-size: 0.24rem;
  padding: 0;
  color: #7b7b7b;
  line-height: 0.75rem;
}
.info .item {
  line-height: 20px;
  margin: 0.2rem 0;
}
.info .item .name {
  color: #666666;
}
.info .item .value {
  padding-left: 10px;
  color: #333333;
}
.info .item.more {
  text-align: center;
  height: 0.72rem;
  line-height: 0.72rem;
  color: #f22321;
}
/* infoTitle */
.infoTitle {
  width: 100%;
  margin: 0 auto;
  position: relative;
  font-size: 18px;
}
.infoTitle::after {
  /*  width: 0;
  height: 0;
  border-top: 12px solid black;
  border-right: 8px solid transparent;
  border-left: 8px solid transparent;
  content: " ";
  position: absolute;
  left: 18px;
  top: 3px;
  transform: rotate(270deg);*/
}
.infoTitle span {
  padding-left: 20px;
  font-weight: bold;
}
.infoTitle.huxing {
  /*color: #d4a783;*/
  color: #000000;
}
.infoTitle.huxing::after {
  border-top-color: #d4a783;
}

.infoTitle.maidian {
  color: #000000;
}
.infoTitle.maidian::after {
  border-top-color: #ce4141;
}

.infoTitle.daohang {
  color: #000000;
}
.infoTitle.daohang::after {
  border-top-color: #4173ff;
}

.infoTitle.zhoubian {
  color: #000000;
}
.infoTitle.zhoubian::after {
  border-top-color: #219bd1;
}

/* 项目详情 */

.detail {
  background-color: #fff;
  padding: 0 20px;
  position: relative;
  /*  border-top-left-radius: 0.125rem;
  border-top-right-radius: 0.125rem;*/
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
}

.detail .item {
  display: flex;
  align-items: baseline;
  margin: 0.2rem 0;
}

.detail .item .name {
  font-size: 0.28rem;
  /* font-weight: 500; */
  width: 30%;
  padding: 0;
  color: #7b7b7b;
}

.detail .item .value {
  font-size: 0.28rem;
  width: 70%;
  line-height: 0.4rem;
}

/* 项目买点 */
.houseIntroduce {
  width: 90%;
  margin: 0 auto;
  line-height: 20px;
  padding: 10px 0;
  color: #7b7b7b;
  font-size: 0.28rem;
}
.houseIntroduce ul {
  list-style-type: disc;
  padding: 0 18px;
  color: #ce4141;
}
.houseIntroduce ul span {
  color: #333333;
}
.t7Map {
  margin: 0.3rem 0;
  width: 100%;
  height: 3rem;
}
/* 交通导航 */
.jiaotongdaohang ul {
  width: 90%;
  margin: 10px auto 10px auto;
  list-style: none;
  line-height: 20px;
  text-align: justify;
}
/* 周边 */
.zhoubian {
  width: 100%;
  margin-top: 15px;
}
.zhoubian_subtitle {
  width: 90%;
  margin-left: 5%;
  margin-top: 10px;
  font-size: 16px;
  /* padding: 5px; */
  /* width: 60px; */
  text-align: left;
  font-weight: 550;
}
/* .zhoubian_subtitle.jiaoyupeitao {
  color: #103e8e;
  background-color: #e9f1ff;
}
.zhoubian_subtitle.shenghuopeitao {
  color: #8e1054;
  background-color: #ffe9f7;
}
.zhoubian_subtitle.shangyepeitao {
  color: #10518e;
  background-color: #e9f5ff;
}
.zhoubian_subtitle.yiliaopeitao {
  color: #108e7e;
  background-color: #e9fff1;
} */
.zhoubian_content {
  margin-top: 10px;
  line-height: 20px;
  text-align: justify;
  width: 90%;
  margin: 10px auto 10px auto;
}
.zhoubian_content ul {
  list-style: none;
}

.projectphone {
  color: #333333;
  width: 90%;
  margin: 0 auto;
  line-height: 30px;
  font-size: 16px;
  background: url("https://assets.rurushishi.com/yq-rs-make/zhongdian/icon_mobile.png")
    no-repeat left center;
  background-size: 0.3rem 0.3rem;
  padding-left: 0.5rem;
  padding-top: 3px;
}
.declare {
  background-color: #f6f6f6;
  font-size: 12px;
  color: #9f9f9f;
  line-height: 17px;
  padding: 15px;
  text-align: justify;
}
.myline {
  height: 5px;
  width: 100%;
  background-color: #ededed;
  margin-bottom: 20px;
}
.myline.nobottom {
  margin-bottom: 0;
}
.fd-layer {
  padding: 10px 0;
}
.fd-layer > img {
  display: block;
  width: 92%;
  margin: 0 auto;
}
.icon_map {
  padding-left: 5px;
  width: 0.9rem;
  height: 0.37rem;
}
.photo {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 90%;
  margin: 0.3rem auto;
}
.photo .item1,
.item3 {
  width: 60%;
}
.photo .item2,
.item4 {
  margin-left: 2%;
  width: 38%;
}
.photo .item3,
.item4 {
  margin-top: 0.2rem;
}
.photo .item {
  position: relative;
}
.photo .item > img {
  width: 100%;
  height: 2.4rem;
  object-fit: cover;
}
.photo .item .name {
  position: absolute;
  bottom: 0;
  height: 0.6rem;
  line-height: 0.6rem;
  width: 100%;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  z-index: 1;
}
.photo .item .no {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 2;
}
.fangdai {
  position: absolute;
  width: 0.99rem;
  height: 0.99rem;
  top: 0.3rem;
  right: 0.3rem;
  background: url("https://assets.rurushishi.com/yq-rs-make/huafa/fangdaijisuanqi.png")
    no-repeat center center;
  background-size: 0.99rem 0.99rem;
}
.more-btn {
  width: 92%;
  height: 0.88rem;
  line-height: 0.88rem;
  background-color: #ffede1;
  color: #ffa45b;
  margin: 0.2rem auto;
  text-align: center;
}
.t7_zd {
  background-color: #f7f6fb;
}
.t7_zd >>> .swiper-pagination-bullets {
  bottom: 40px !important;
}
.zd_pro_info {
  width: 92%;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 6px;
  margin-top: -35px;
}
.zd_visitors {
  width: 92%;
  margin: 0.3rem auto 0 auto;
  background-color: #fff;
  border-radius: 6px;
  padding: 5px 0 8px 0;
}
.zd_visitors >>> .gather {
  padding: 0 0.3rem;
}
.zd_actareas {
  width: 92%;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 6px;
}
.zd_actareas >>> .showact {
  padding: 0.1rem 0 0.2rem 0;
}
.zd_actareas >>> img {
  width: 98% !important;
}
.zd-common-box {
  width: 92%;
  margin: 0.3rem auto 0 auto;
  background-color: #fff;
  border-radius: 6px;
  padding: 0.3rem 0 0.1rem 0;
}
.item.zd .value {
  background: url("https://assets.rurushishi.com/yq-rs-make/zhongdian/icon_location.png")
    no-repeat left center;
  background-size: 0.3rem 0.3rem;
  padding-left: 0.5rem;
}
.t7_zd .tag-layer {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.t7_zd .tag-layer .tag {
  background-color: rgba(255, 255, 255, 0.6);
  padding: 4px 8px;
  font-size: 0.22rem;
  color: #f22321;
  border-radius: 4px;
  margin-right: 5px;
  max-width: 1.3rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border: 1px solid #f22321;
}
.t7_zd .tag-layer .tag.red {
  color: #fff;
  background-color: #f22321;
}
</style>